function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M36.0053 24.2632C36.0053 24.7052 35.6149 24.9905 35.1812 24.9905H11.9232C11.4895 24.9905 11.1482 24.7052 11.1482 24.2632V10.6019C11.1482 10.1599 11.4895 9.85179 11.9232 9.85179H35.1812C35.6149 9.85179 36.0053 10.1599 36.0053 10.6019V24.2632Z",
  fill: "#B4114C"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M26.2192 25.0928H21.3271V12.5332H26.2192V25.0928Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38 12.4171C38 12.5709 37.6195 12.741 37.113 12.741H9.94646C9.43987 12.741 9 12.5709 9 12.4171V7.66411C9 7.51023 9.43987 7.3706 9.94646 7.3706H37.113C37.6195 7.3706 38 7.51023 38 7.66411V12.4171Z",
  fill: "#B4114C"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M26.273 12.7407H21.3518V6.83332H26.273V12.7407Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.7382 7.36583C30.5359 8.56534 24.9502 6.98897 24.9502 6.98897V4.16181C24.9502 4.16181 30.5426 1.07753 31.7449 2.27694C32.3794 2.91003 32.3727 6.73284 31.7382 7.36583Z",
  fill: "white"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.9628 7.36583C17.1651 8.56534 22.7746 6.98897 22.7746 6.98897V4.16181C22.7746 4.16181 17.1702 1.07753 15.968 2.27694C15.3334 2.91003 15.3283 6.73284 15.9628 7.36583Z",
  fill: "white"
}));

var _ref8 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter4_d)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M26.2453 5.85844C26.2453 7.15953 25.1881 8.21436 23.8837 8.21436C22.5796 8.21436 21.5222 7.15953 21.5222 5.85844C21.5222 4.55734 22.5796 3.50252 23.8837 3.50252C25.1881 3.50252 26.2453 4.55734 26.2453 5.85844Z",
  fill: "white"
}));

var _ref9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d",
  x: 2.5556,
  y: 3.40736,
  width: 42.0423,
  height: 32.3239,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14815
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.2963
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_d",
  x: 0.407409,
  y: 0.926162,
  width: 46.1852,
  height: 22.5556,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14815
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4.2963
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_d",
  x: 22.802,
  y: 2,
  width: 11.5635,
  height: 10.1125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14815
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.07407
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_d",
  x: 13.3414,
  y: 2,
  width: 11.5814,
  height: 10.1125,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14815
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.07407
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter4_d",
  x: 19.3741,
  y: 3.50244,
  width: 9.01941,
  height: 9.00813,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2.14815
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.07407
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 36,
    viewBox: "0 0 47 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.8fa4b1b7.svg";
export { ForwardRef as ReactComponent };